export default Object.freeze({
  /**
   * @param {function} onResize
   */
  registerWatcher: (onResize) => {
    window.addEventListener('resize', onResize);
    window.setTimeout(onResize, 0);
  },
  /**
   * @param {function} onResize
   */
  unregisterWatcher: (onResize) => {
    window.removeEventListener('resize', onResize);
  },
  /**
   * @returns {number}
   */
  get width() {
    return window.document.body.offsetWidth;
  },
  /**
   * @returns {number}
   */
  get height() {
    return window.document.body.offsetHeight;
  },
  /**
   * @returns {string}
   */
  get size() {
    const width = this.width;
    if (width >= 1600) return 'xxl';
    else if (width >= 1200) return 'xl';
    else if (width >= 992) return 'lg';
    else if (width >= 768) return 'md';
    else if (width >= 576) return 'sm';
    else return 'xs';
  }
});


// WEBPACK FOOTER //
// ./src/utils/screen.js